import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { State } from 'src/app/interfaces/state';
import { StateFull } from 'src/app/interfaces/state-full';

import { PrimaryTradeLicenseRequirementForm } from './primary-trade-license-requirement-form';

export class SubNationalDivisionForm extends FormGroup<{
  id: FormControl<number | undefined>;
  country: FormControl<'USA' | 'Canada' | undefined>;
  abbreviation: FormControl<State | undefined>;
  name: FormControl<StateFull | undefined>;
  launched: FormControl<boolean>;

  PrimaryTradeLicenseRequirements?: FormArray<PrimaryTradeLicenseRequirementForm>;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined, { nonNullable: true }),
      country: new FormControl<'USA' | 'Canada' | undefined>(undefined, {
        nonNullable: true
      }),
      abbreviation: new FormControl<State | undefined>(undefined, {
        nonNullable: true
      }),
      name: new FormControl<StateFull | undefined>(undefined, {
        nonNullable: true
      }),
      launched: new FormControl<boolean>(false, { nonNullable: true })
    });
  }
}
